export const formatPhoneOnlyNumbers = (phone: string) => phone.replace(/[ ()*-]+/g, '');
